module.exports = __webpack_public_path__ + "img/A-4085016-1512900397-9128.jpeg.e1860106.jpg";